<div class="pageheader">
  <h1>Be Found By Startups</h1>
</div>

<div class="pagecontent"
     *ngIf="state$ | async as state">
  <!-- <app-criteria-define [id]="state.setId"></app-criteria-define> -->
  <app-criteria-define-crunch [setId]="state.setId"></app-criteria-define-crunch>
</div>
